import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';
import { FormSubmission } from '../../../types/FormSubmission';

export type CreateFormSubmissionParams = {
  event_form_template_uuid: string;
  email: string;
};

export const postFormSubmission = async (params: CreateFormSubmissionParams) => {
  const response = await CustomAxios.post('form_submissions', params);
  const { data } = response;
  return data;
};

type UseCreateFormSubmissionProps = {
  onSuccessCallback?: (formSubmission: FormSubmission) => void;
  onErrorCallback?: (err?: AxiosResponse) => void;
};

export function useCreateFormSubmission({ onSuccessCallback, onErrorCallback }: UseCreateFormSubmissionProps) {
  return useMutation({
    mutationKey: [mutationKeys.createFormSubmission],
    mutationFn: (params: CreateFormSubmissionParams) => postFormSubmission(params),
    onSuccess: (formSubmission: FormSubmission) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allFormSubmissions] });
      onSuccessCallback?.(formSubmission);
    },
    onError: (err: AxiosError) => {
      if (err.response?.status === 400) {
        onErrorCallback?.(err.response);
      } else {
        console.error(err);
      }
    },
  });
}
